<template>
  <section>
    <h3 class="tw-rounded-lg tw-py-2 tw-px-4 tw-font-poppins tw-text-sm tw-opacity-30">
      {{ name }}
    </h3>
    <ul class="tw-flex tw-flex-col tw-gap-1">
      <slot />
    </ul>
  </section>
</template>


<script>
// import SubComponent from '../components/SubComponent'

export default {
  name: 'AdvisorCoreNavGroup',
  components: { /* Subcomponents */ },
  props: {
    name: { type: String, required: true },
    // prop: { type: String, required: true },
    // prop: String,
  },
  data() {
    return { /* Local variables */ };
  },
  computed: { /*
      Creates a new property
      Updates when any dependant property changes */
  },
  watch: { /*
      Watches an existing property
      Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {},
};
</script>


<style scoped>

</style>
